export default __webpack_public_path__ + "static/media/featured-prof.90243b3e.png";